<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
          <form action="">
            <div class="form-row">
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label for="form_no">TNA Form No.</label>
                <input type="number"
                       v-model="search_data.form_no"  v-validate="{ regex: /^[0-9]+$/ }" id="form_no"
                       name="form_no"
                       class="form-control form-control-sm"
                       placeholder="Search by form No"
                />
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label for="household_number">Household Number</label>
                <input type="text"
                       v-model="search_data.household_number" id="household_number"
                       name="household_number"
                       class="form-control form-control-sm"
                       placeholder="Search by HH No"
                />
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label for="name">Household Head Name</label>
                <input
                    type="text"
                    v-model="search_data.name" id="name" name="name"
                    class="form-control form-control-sm"
                    placeholder="Search by Name"
                />
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label for="c_mouza_id">Mouza</label>
                <select
                    v-model="search_data.c_mouza_id"
                    class="form-control form-control-sm"
                    name="c_mouza_id"
                    id="c_mouza_id"
                >
                  <option selected :value="''">Select a Mouza</option>
                  <option
                      v-for="(mouza, index) in mouzas"
                      :key="index"
                      :value="mouza.id"
                  >{{ mouza.id }} : {{ mouza.desc }}
                  </option
                  >
                </select>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-4">
                <label for="c_village_id">Village</label>
                <select
                    v-model="search_data.c_village_id"
                    id="c_village_id" name="c_village_id"
                    class="custom-select custom-select-sm"
                >
                  <option selected :value="''">Select a village</option>
                  <option
                      v-for="(village, index) in villages"
                      :key="index"
                      :value="village.id">{{ village.id }} : {{ village.desc }}
                  </option>
                </select>
              </div>

            </div>
            <button
                @click.prevent="search"
                class="btn btn-success btn-sm mt-2"
            >
              Search
            </button>
          </form>
        </b-card>


        <b-card>
          <div v-if="trainees.total > 0" class="row mb-2">
            <div class="col-sm-8">
              <span class="badge badge-success mr-2">Total Search Data Found: {{ trainees.total }}</span>
            </div>
          </div>
          <div class="scrollable-table" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
              <tr>
                <th>Sl</th>
                <th>Household Number</th>
                <th>Name</th>
                <th>NID</th>
                <th>Mobile</th>
                <th>Father Name</th>
                <th>Mother Name</th>
                <th>Village</th>
                <th>Mouza</th>
                <th>View Profile</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(trainee, index) in trainees.data" :key="index">
                <td>{{ trainees.from + index }}</td>
                <td>{{ trainee.household_number }}</td>
                <td >
                  <router-link :to="{
                          name: 'traineeView',
                          params: { trainee_id: trainee.id }}" tag="a" title="Trainee Details" target="_blank">

                            <span v-for="image in trainee.files" :key="image.id" class="mr-1">
                                <span v-if="image.file_tag === '1'">
                                  <img class="rounded-circle" :src="image.name" alt="" width="30px" height="30px"/>
                                </span>
                            </span>
                    {{ trainee.name }}
                  </router-link>
                </td>
                <td>{{ trainee.nid }}</td>
                <td>{{ trainee.mobile }}</td>
                <td>{{ trainee.father_husband_name }}</td>
                <td>{{ trainee.mother_name }}</td>
                <td>{{ trainee.village.desc }}</td>
                <td>{{ trainee.mouza.desc }}</td>
                <td>
                  <router-link :to="{
                          name: 'traineeProfileInfo',
                          params: { trainee_id: trainee.id }}" tag="a" title="View Profile" target="_blank">
                    <i class="fe-eye"></i>
                  </router-link>
                </td>
              </tr>
              </tbody>
            </table>
          </div>

          <h5 v-if="trainees.total == 0" class="text-center text-secondary">
            No Data Found
          </h5>
          <div class="float-right">
            <pagination :data="trainees" :limit="2" @pagination-change-page="getResults"></pagination>
          </div>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@src/app.config";
import Layout from "@layouts/main";
import PageHeader from "@components/page-header";
import http from "@state/http";

export default {
  page: {
    title: "Trainee List",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Layout, PageHeader},
  data() {
    return {
      title: "Search Trainee",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Trainee",
          active: true
        }
      ],
      trainees: {},
      search_data: {
        form_no: '',
        household_number: '',
        name: '',
        c_mouza_id: '',
        c_village_id: '',
      },
      villages: [],
      mouzas: [],
      trainee: {},
    };
  },


  mounted() {
    this.getCodes();
  },
  methods: {
    getCodes() {
      http.get("api/ses/codes").then(response => {
        if (!response.error) {
          let data = response.data;
          this.villages = data.villages;
          this.mouzas = data.mouzas;
        }
      });
    },
    search() {
      http.post("api/trainees/search/list", this.search_data).then(response => {
        if (!response.error) {
          this.flag = true;
          this.trainees = response.data.trainees;
        }
      });
    },
    getResults(page = 1) {
      http.post('api/trainees/search/list?page=' + page, this.search_data)
          .then(response => {
            this.flag = true;
            this.trainees = response.data.trainees;
          });
    }
  },
  computed: {
    userPermission() {
      return this.$store.state.user
    }
  },
  created() {
    this.$store.dispatch('getUserPermission')
  },
};
</script>
